function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ToolEdit_Hover",
  transform: "translate(.365)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_24",
  className: "background",
  "data-name": "Ellipse 24",
  cx: 20,
  cy: 20,
  r: 20,
  transform: "translate(-.365)",
  fill: "#98c3d9"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_166",
  className: "edit",
  "data-name": "Group 166",
  transform: "translate(9.635 9)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_72",
  "data-name": "Rectangle 72",
  transform: "rotate(45 3.99 19.481)",
  fill: "#002d56",
  d: "M0 0h2.988v12.913H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M1238.017 475.887l-1.038 3.151 3.151-1.038z",
  transform: "translate(-1232.205 -463.872)",
  fill: "#002d56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_73",
  "data-name": "Rectangle 73",
  transform: "rotate(45 8.914 21.52)",
  fill: "#002d56",
  d: "M0 0h2.988v3.078H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M12.45 2.371H1V18.94h16.57V7.493",
  fill: "none",
  stroke: "#082d56",
  strokeLinecap: "square",
  strokeWidth: 1
})));

function SvgEditRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditRound);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj4KICA8ZyBpZD0iVG9vbEVkaXRfSG92ZXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMzY1KSI+CiAgICA8Y2lyY2xlIGlkPSJFbGxpcHNlXzI0IiBjbGFzcz0iYmFja2dyb3VuZCIgZGF0YS1uYW1lPSJFbGxpcHNlIDI0IiBjeD0iMjAiIGN5PSIyMCIgcj0iMjAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjM2NSkiIGZpbGw9IiM5OGMzZDkiLz4KICAgIDxnIGlkPSJHcm91cF8xNjYiIGNsYXNzPSJlZGl0IiBkYXRhLW5hbWU9Ikdyb3VwIDE2NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS42MzUgOSkiPgogICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzcyIiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA3MiIgd2lkdGg9IjIuOTg4IiBoZWlnaHQ9IjEyLjkxMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTQuOTQ0IDIuODg0KSByb3RhdGUoNDUpIiBmaWxsPSIjMDAyZDU2Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzI3IiBkYXRhLW5hbWU9IlBhdGggMjciIGQ9Ik0xMjM4LjAxNyw0NzUuODg3bC0xLjAzOCwzLjE1MUwxMjQwLjEzLDQ3OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjMyLjIwNSAtNDYzLjg3MikiIGZpbGw9IiMwMDJkNTYiLz4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV83MyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNzMiIHdpZHRoPSIyLjk4OCIgaGVpZ2h0PSIzLjA3OCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTcuODI3IDApIHJvdGF0ZSg0NSkiIGZpbGw9IiMwMDJkNTYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMjgiIGRhdGEtbmFtZT0iUGF0aCAyOCIgZD0iTTEyNDIuNjgsNDY1LjQ3OGgtMTEuNDV2MTYuNTY5SDEyNDcuOFY0NzAuNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyMzAuMjMgLTQ2My4xMDcpIiBmaWxsPSJub25lIiBzdHJva2U9IiMwODJkNTYiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };